( function () {
	'use strict';

	function obsEditName ( $document, $timeout, TOOLTIP_MESSAGES ) {
		function link ( scope, element ) {
			element.data( 'editName', true );

			scope.editName = false;
			scope.isEmpty  = false;
			scope.tooltip = TOOLTIP_MESSAGES;

			scope.$watch( 'data', function ( res ) {
				if ( res ) {
					scope.tempName = res;
				}
			} );

			angular.element( $document[ 0 ].body ).on( 'click', function ( event ) {
				var saveSubmit = angular.element( event.target ).hasClass( 'obs-submit' );
				var isClicked  = angular.element( event.target ).inheritedData( 'editName' );

				if ( saveSubmit ) {
					scope.editName = false;
					return true;
				}

				if ( !isClicked && scope.data ) {
					scope.tempName = scope.data;
					scope.editName = false;
					scope.$apply();
				}
			} );

			function changeObsName ( event ) {
				if ( event.keyCode === 13 || event.keyCode === 27 ) {
					scope.tempName = scope.data;
					scope.isEmpty  = false;
					scope.editName = false;
					return scope.editName;
				}

				if ( scope.tempName.length > 0 && scope.tempName.length <= 140 && angular.isDefined( scope.tempName.length ) ) {
					scope.isEmpty = false;
					scope.data    = scope.tempName.trim();
					return scope.data;
				}

				scope.isEmpty = true;

				return scope.isEmpty;
			}

			function editObsName () {
				$timeout( function () {
					angular.element( element ).find( '[ name = \'obsName\' ]' )[ 0 ].focus();
				} );
				scope.editName = true;
			}

			scope.changeObsName = changeObsName;
			scope.editObsName   = editObsName;
		}

		var directive = {
			'link'        : link,
			'restrict'    : 'E',
			'templateUrl' : '/templates/observations/observation-edit/obs-edit-name.html',
			'scope'       : {
				'data'   : '=',
				'update' : '&'
			}
		};

		return directive;
	}

	angular
		.module( 'app.observations' )
		.directive( 'obsEditName', obsEditName );

	obsEditName.$inject = [ '$document', '$timeout', 'TOOLTIP_MESSAGES' ];
} )( );
